



























import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import BtnDefault from '@/components/UI/BtnDefault.vue';
import IClose from '@/components/icons/IClose.vue'
import ICheck from '@/components/icons/ICheck.vue'

const dialog = namespace('dialog')

@Component({
  components: {
    BtnDefault,
    'i-close': IClose,
    'i-check': ICheck,
  }
})
export default class ModalSupport extends Vue {
  @dialog.Getter('modalSupportShow') protected modalSupportShow: any
  @dialog.Mutation('SetModalSupportShow') protected SetModalSupportShow: any

  closeDialog() {
    this.SetModalSupportShow(false)
  }

}
